export default __webpack_public_path__ + "static/media/greentick.8d43d71b.svg";